import { combineEpics } from 'redux-observable';
import { createPlaceEpic } from './create-place-epic';
import { loadPlaceEpic } from './load-place-epic';
import { updatePlaceEpic } from './update-place-epic';

export const placeEpic = combineEpics(
  createPlaceEpic,
  loadPlaceEpic,
  updatePlaceEpic,
);
